var map = {
	"./cn.svg": "8687",
	"./email.svg": "9055",
	"./gb.svg": "bf20",
	"./global.svg": "1cd1",
	"./investment-approach.jpg": "3b0c",
	"./opp-direct-investment.png": "5e76",
	"./opp-exclusive-service.jpg": "06d1",
	"./opp-qflp.jpg": "f88b",
	"./opp-real-estate.jpg": "870e",
	"./plane.svg": "07b8",
	"./question.svg": "8bbe",
	"./ship.svg": "f754",
	"./uk-real-estate-hotel.jpg": "addc",
	"./uk-real-estate-residential.jpg": "48d4",
	"./vcc.jpg": "0e5d",
	"./welcome0.jpg": "b3e3",
	"./welcome1.jpg": "83e1",
	"./welcome3.jpg": "db96",
	"./welcome4.jpg": "4713"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";